(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aeris-compare-results"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCompareResults(section) {
    var row = section.querySelector('[data-cr-row]');
    var prevBtn = section.querySelector('[data-cr-prev]');
    var nextBtn = section.querySelector('[data-cr-next]');
    var currentEl = section.querySelector('[data-cr-current]');
    var totalEl = section.querySelector('[data-cr-total]');
    if (!row) return;

    var items = row.children;

    function itemWidth() {
      return items.length ? items[0].getBoundingClientRect().width + 24 : 0;
    }

    function currentIndex() {
      return Math.round(row.scrollLeft / itemWidth()) + 1;
    }

    function refresh() {
      var total = items.length;
      var current = Math.min(currentIndex(), total);
      if (totalEl) totalEl.textContent = total;
      if (currentEl) currentEl.textContent = total ? current : 0;
      if (prevBtn) prevBtn.disabled = row.scrollLeft <= 0;
      if (nextBtn) nextBtn.disabled = row.scrollLeft >= row.scrollWidth - row.clientWidth - 2;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        row.scrollBy({ left: -itemWidth(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        row.scrollBy({ left: itemWidth(), behavior: 'smooth' });
      });
    }

    row.addEventListener('scroll', function () {
      window.requestAnimationFrame(refresh);
    });

    refresh();
  }

  function scan(root) {
    (root || document).querySelectorAll('.cr__section').forEach(function (section) {
      if (section.dataset.crInit) return;
      section.dataset.crInit = 'true';
      initCompareResults(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
    });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aeris-percentage-stats"] && !Shopify.designMode) return;
  try {
    

(function() {

  var containers = document.querySelectorAll('[data-pct-stats]');

  if (!containers.length) return;



  function animateStat(statEl) {

    var target = parseInt(statEl.dataset.target, 10);

    var ringEl = statEl.querySelector('[data-ring]');

    var pctEl  = statEl.querySelector('[data-pct]');

    var current = 0;

    var from = 0;



    function lerp(v0, v1, t) {

      var next = (1 - t) * v0 + t * v1;

      return Math.abs(v1 - next) < 0.5 ? v1 : next;

    }



    function tick() {

      from = lerp(from, target, 0.08);

      current = Math.round(from);

      var deg = current * 3.6;

      ringEl.style.background =

        'conic-gradient(currentColor ' + deg + 'deg, transparent ' + deg + 'deg)';

      pctEl.textContent = statEl.dataset.display ? statEl.dataset.display : current + '%';

      if (current < target) {

        setTimeout(tick, 30);

      }

    }

    tick();

  }



  containers.forEach(function(container) {

    var stats = container.querySelectorAll('.pct__stat');

    var animated = false;



    var observer = new IntersectionObserver(function(entries) {

      entries.forEach(function(entry) {

        if (entry.isIntersecting && !animated) {

          animated = true;

          stats.forEach(function(stat, i) {

            setTimeout(function() { animateStat(stat); }, i * 200);

          });

          observer.disconnect();

        }

      });

    }, { threshold: 0.3 });



    observer.observe(container);

  });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aeris-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    const init = (root) => {
      if (root.dataset.axrReady) return;
      root.dataset.axrReady = '1';
      const track = root.querySelector('[data-axr-track]');
      const list = track && track.querySelector('.axr__list');
      if (!track || !list) return;

      const autoplay = root.dataset.autoplay === 'true' && !reduce.matches;
      const speed = Number(root.dataset.speed) || 30;
      let paused = false;
      let half = 0;
      let sync = () => {};

      if (autoplay && list.children.length) {
        // Repeat the cards until the row is at least one set wider than the viewport, so the
        // loop is seamless even with only a few reviews. Clones are hidden from assistive tech.
        const originals = [...list.children];
        const addSet = () => originals.forEach((item) => {
          const clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.removeAttribute('data-shopify-editor-block');
          clone.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
          list.appendChild(clone);
        });
        addSet();
        const measure = () => {
          const first = list.children[0];
          const firstClone = list.children[originals.length];
          half = firstClone.offsetLeft - first.offsetLeft;
          let guard = 0;
          while (list.scrollWidth < track.clientWidth + half * 2 && guard < 12) { addSet(); guard += 1; }
        };
        measure();
        // Re-measure only when the track itself changes width; window resize also fires as the
        // mobile URL bar shows and hides during scrolling.
        let trackWidth = track.clientWidth;
        new ResizeObserver(() => {
          if (track.clientWidth === trackWidth) return;
          trackWidth = track.clientWidth;
          measure();
        }).observe(track);

        // The position is kept here and only written to scrollLeft, never read back per frame,
        // so the loop doesn't force a layout of the whole page. It runs only while on screen.
        let pos = 0;
        let rafId = 0;
        let visible = false;
        let last = 0;
        let carry = 0;
        const tick = (now) => {
          const dt = last ? Math.min(now - last, 64) / 1000 : 0;
          last = now;
          carry += speed * dt;
          const step = Math.floor(carry);
          if (step) {
            carry -= step;
            pos += step;
            if (pos >= half) pos -= half;
            track.scrollLeft = pos;
          }
          rafId = requestAnimationFrame(tick);
        };
        sync = () => {
          const run = visible && !paused && half > 0 && !document.hidden;
          if (run && !rafId) {
            pos = track.scrollLeft;
            last = 0;
            carry = 0;
            rafId = requestAnimationFrame(tick);
          } else if (!run && rafId) {
            cancelAnimationFrame(rafId);
            rafId = 0;
          }
        };
        new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; sync(); }).observe(track);
        document.addEventListener('visibilitychange', sync);
      }

      const pause = () => { paused = true; sync(); };
      // Stay paused while a review is expanded so it doesn't scroll away mid-read.
      const resume = () => { paused = !!list.querySelector('.axr-card.is-open'); sync(); };

      // Show "Read more" only on cards whose quote is actually clamped.
      const flagLong = () => list.querySelectorAll('.axr-card:not(.is-open)').forEach((card) => {
        const quote = card.querySelector('[data-axr-quote]');
        const more = card.querySelector('[data-axr-more]');
        if (quote && more) more.hidden = quote.scrollHeight <= quote.clientHeight + 1;
      });
      flagLong();
      if (document.fonts) document.fonts.ready.then(flagLong);
      list.addEventListener('click', (e) => {
        const more = e.target.closest('[data-axr-more]');
        if (!more) return;
        const open = more.closest('.axr-card').classList.toggle('is-open');
        more.setAttribute('aria-expanded', String(open));
        more.textContent = open ? 'Show less' : 'Read more';
        if (open) pause();
        else resume();
      });
      track.addEventListener('pointerenter', pause);
      track.addEventListener('pointerleave', resume);
      track.addEventListener('touchstart', pause, { passive: true });
      track.addEventListener('touchend', () => setTimeout(resume, 1200), { passive: true });
      track.addEventListener('focusin', pause);
      track.addEventListener('focusout', resume);

      // Drag to scroll with a mouse; touch uses native scrolling.
      let dragging = false;
      let startX = 0;
      let startLeft = 0;
      track.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse' || e.target.closest('a, button')) return;
        dragging = true;
        startX = e.clientX;
        startLeft = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture(e.pointerId);
      });
      track.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        track.scrollLeft = startLeft - (e.clientX - startX);
        if (half && track.scrollLeft >= half) track.scrollLeft -= half;
      });
      const endDrag = () => { dragging = false; track.classList.remove('is-dragging'); };
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);

      const step = () => {
        const card = list.querySelector('.axr__item');
        return card ? card.getBoundingClientRect().width + 16 : 320;
      };
      const prev = root.querySelector('[data-axr-prev]');
      const next = root.querySelector('[data-axr-next]');
      if (prev) prev.addEventListener('click', () => {
        if (half && track.scrollLeft < step()) track.scrollLeft += half;
        track.scrollBy({ left: -step(), behavior: reduce.matches ? 'auto' : 'smooth' });
      });
      if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: reduce.matches ? 'auto' : 'smooth' }));
    };

    const boot = () => document.querySelectorAll('[data-axr]').forEach(init);
    boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aeris-testimonials"] && !Shopify.designMode) return;
  try {
    
(function() {
  var section = document.currentScript.closest('.ae-testi') || document.querySelector('.ae-testi');
  if (!section) return;
  var id = section.querySelector('.ae-testi__track').id.replace('ae-testi-track-','');
  var track = document.getElementById('ae-testi-track-' + id);
  var prev  = document.getElementById('ae-testi-prev-' + id);
  var next  = document.getElementById('ae-testi-next-' + id);
  if (!track || !prev || !next) return;
  function cardWidth() {
    var card = track.querySelector('.ae-testi__card');
    if (!card) return 336;
    return card.offsetWidth + 16;
  }
  prev.addEventListener('click', function() {
    track.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
  });
  next.addEventListener('click', function() {
    track.scrollBy({ left: cardWidth(), behavior: 'smooth' });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initTypewriter(el) {
      // Read phrases from data attribute, fall back to element's original text
      const raw = el.dataset.typewriterPhrases;
      const phrases = raw
        ? JSON.parse(raw)
        : [el.textContent.trim()];

      const typingSpeed   = parseInt(el.dataset.typewriterSpeed   || '75',  10);
      const erasingSpeed  = parseInt(el.dataset.typewriterErase   || '40',  10);
      const pauseAfter    = parseInt(el.dataset.typewriterPause   || '2200', 10);
      const pauseBefore   = parseInt(el.dataset.typewriterBefore  || '400',  10);

      // Build DOM: wrap original content in a span, add cursor
      el.innerHTML = '';
      el.classList.add('aeris-typewriter-wrap');

      const textSpan   = document.createElement('span');
      textSpan.className = 'aeris-typewriter-text';
      const cursor     = document.createElement('span');
      cursor.className = 'aeris-typewriter-cursor';
      cursor.setAttribute('aria-hidden', 'true');

      el.appendChild(textSpan);
      el.appendChild(cursor);

      let phraseIndex = 0;
      let charIndex   = 0;
      let isErasing   = false;

      function tick() {
        const phrase = phrases[phraseIndex % phrases.length];

        if (!isErasing) {
          // Typing forward
          charIndex++;
          textSpan.textContent = phrase.substring(0, charIndex);

          if (charIndex === phrase.length) {
            // Finished typing — pause then start erasing
            isErasing = true;
            setTimeout(tick, pauseAfter);
            return;
          }
          setTimeout(tick, typingSpeed + Math.random() * 30); // tiny jitter for realism
        } else {
          // Erasing
          charIndex--;
          textSpan.textContent = phrase.substring(0, charIndex);

          if (charIndex === 0) {
            // Finished erasing — move to next phrase
            isErasing = false;
            phraseIndex++;
            setTimeout(tick, pauseBefore);
            return;
          }
          setTimeout(tick, erasingSpeed);
        }
      }

      // Kick off after a short initial delay
      setTimeout(tick, 600);
    }

    function setup() {
      document.querySelectorAll('[data-typewriter]').forEach(el => {
        // Avoid double-init
        if (el.dataset.typewriterInit) return;
        el.dataset.typewriterInit = '1';
        initTypewriter(el);
      });
    }

    // Expose for per-section activation scripts
    window.__aerisTypewriterInit = function(el) {
      if (el.dataset.typewriterInit) return;
      el.dataset.typewriterInit = '1';
      initTypewriter(el);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setup);
    } else {
      setup();
    }

    // Re-init on Shopify theme editor section load/reload
    document.addEventListener('shopify:section:load', setup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-rc-track]').forEach(function (track) {
    var id     = track.dataset.rcTrack;
    var prev   = document.querySelector('[data-rc-prev="' + id + '"]');
    var next   = document.querySelector('[data-rc-next="' + id + '"]');
    var dotsEl = document.querySelector('[data-rc-dots="' + id + '"]');
    var cards  = Array.from(track.children);
    var total  = cards.length;
    var idx    = 0;

    function goto(n) {
      idx = (n + total) % total;
      var cardW = cards[idx].offsetWidth;
      var gap   = parseInt(getComputedStyle(track).gap) || 16;
      track.style.transform = 'translateX(-' + (idx * (cardW + gap)) + 'px)';
      if (dotsEl) {
        dotsEl.querySelectorAll('button').forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
          d.setAttribute('aria-selected', i === idx ? 'true' : 'false');
        });
      }
    }

    if (prev) prev.addEventListener('click', function () { goto(idx - 1); });
    if (next) next.addEventListener('click', function () { goto(idx + 1); });

    if (dotsEl) {
      dotsEl.querySelectorAll('button').forEach(function (d) {
        d.addEventListener('click', function () { goto(parseInt(d.dataset.index)); });
      });
    }

    var startX = 0;
    track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) goto(dx < 0 ? idx + 1 : idx - 1);
    }, { passive: true });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
